import 'css-chunksrc/client/scenes/resourceDeactivation/styles.scss';export default {
  "body": "_body_w62l0_1",
  "footer": "_footer_w62l0_8",
  "warning": "_warning_w62l0_17",
  "group": "_group_w62l0_23"
};